export const LOCAL_STORAGE_KEY = {
  AUTH: 'auth',
};
